(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fff-why-panel"] && !Shopify.designMode) return;
  try {
    
  // Retry .play() on autoplay-marked videos. Browsers occasionally block the
  // initial muted-autoplay (e.g. Chrome with "Energy Saver" enabled, Safari with
  // Low Power Mode, or when the tab wasn't focused at first paint). Forcing
  // muted = true and calling play() inside a microtask is the standard recovery.
  (function () {
    var run = function () {
      var videos = document.querySelectorAll('video[data-fff-autoplay]');
      videos.forEach(function (v) {
        v.muted = true;
        v.setAttribute('muted', '');
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () { /* swallow autoplay rejection */ });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }
    // Re-run on Shopify section editor reload so the video plays after merchant edits.
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
